export const LANGUAGES = {
  en: 'en-EN',
  gb: 'en-EN',
  de: 'de-DE',
  fr: 'fr-FR',
  es: 'es-ES',
  hi: 'hi-HI',
  it: 'it-IT',
  nl: 'nl-NL',
  pt: 'pt-PT',
  sk: 'sk-SK',
  el: 'el-GR',
  sl: 'sl-SL',
  ar: 'ar-001',
  ua: 'uk-UA',
  ja: 'ja-JP',
  zh: 'zh-Hans-CN',
};

/**
 * Language subtag → ISO 3166-1 alpha-2 country, for seeding a phone field's default
 * country from the active language.
 *
 * A language subtag is NOT a country code, so it cannot be used directly: `sl` (Slovenian)
 * is Sierra Leone, `ar` (Arabic) is Argentina, and `el`/`hi`/`ja`/`zh`/`uk` are not
 * countries at all. Nor can the region subtag of LANGUAGES be used, because several of its
 * values carry no usable region (`en-EN`, `hi-HI`, `sl-SL`, `ar-001`). Hence this explicit
 * table, which is the only correct mapping for the languages this app actually ships.
 *
 * intl-tel-input matches its `initialCountry` case-sensitively against lower-case ISO2
 * codes and silently falls back on a miss, so every value here is lower case.
 *
 * `ar-001` is world-wide Arabic with no country to infer, so it is deliberately absent —
 * callers fall back to their own default rather than guess a country for it.
 */
export const LANGUAGE_COUNTRIES: { [languageSubtag: string]: string } = {
  en: 'gb',
  gb: 'gb',
  de: 'de',
  fr: 'fr',
  es: 'es',
  hi: 'in',
  it: 'it',
  nl: 'nl',
  pt: 'pt',
  sk: 'sk',
  el: 'gr',
  sl: 'si',
  ua: 'ua',
  uk: 'ua',
  ja: 'jp',
  zh: 'cn',
};
